import { render } from "./WifiConfig.vue?vue&type=template&id=98a88bc0&scoped=true"
import script from "./WifiConfig.vue?vue&type=script&lang=js"
export * from "./WifiConfig.vue?vue&type=script&lang=js"

import "./WifiConfig.vue?vue&type=style&index=0&id=98a88bc0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\32114\\Desktop\\esp\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98a88bc0"]])

export default __exports__